import { StyledAvatar } from './Avatar.styled';

const Avatar = ({ figure, onMouseEnter, onClick, isSelected = false, isHovered = false }) => {
  return (
    <div onMouseEnter={onMouseEnter} onClick={() => onClick ? onClick(figure) : false }>
      <StyledAvatar $selected={isSelected} $hovered={isHovered}>
        <div className='avatar-border'>
          <div className='avatar-internal-border'>
	    <div style={{overflow: 'hidden', height: '100%', width: '100%'}}>
              <img src={figure.getAvatarThumbSource()} />
            </div>
          </div>
        </div>
	<div className='avatar-decorator'>
          <div />
        </div>
      </StyledAvatar>
    </div>
  );
};

export default Avatar;
